import React from "react";

const ContactMap = () => {
return (
<>
  <section class="contact-map">
    <div class="container-fluid">
      <div class="google-map google-map__contact">
        <iframe title="template google map"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d6093.408443674448!2d28.92501924680381!3d40.21564190308492!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14ca11e94e55badd%3A0xc124b3de7f490531!2sSeymen%20Kimya!5e0!3m2!1sen!2str!4v1761811104730!5m2!1sen!2str"
          class="map__contact" allowfullscreen="">
        </iframe>
      </div>
    </div>
  </section>
</>
);
};

export default ContactMap;